import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Reveal } from '../hooks/useReveal';
import { SectionTitle } from './About';
import { portraits, wixImg, wixImgFull } from '../mock';
import { Dialog, DialogContent } from './ui/dialog';

const Gallery = () => {
  const { t } = useLanguage();
  const [active, setActive] = useState(null);

  return (
    <section id="gallery" className="section-pad bg-gradient-to-b from-[#14120d] via-[#1e1a11] to-[#14120d]">
      <div className="max-w-6xl mx-auto">
        <Reveal>
          <SectionTitle eyebrow={t.gallery.eyebrow} title={t.gallery.title} subtitle={t.gallery.subtitle} />
        </Reveal>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-4 mt-12">
          {portraits.map((id, i) => (
            <Reveal key={id} delay={(i % 4) * 60}>
              <button
                onClick={() => setActive(id)}
                className="gallery-item block w-full aspect-[4/5] overflow-hidden rounded-sm border border-[#e6b83f]/15 hover:border-[#e6b83f]/50 transition-colors"
              >
                <img src={wixImg(id)} alt="LAJO" loading="lazy" className="w-full h-full object-cover" />
              </button>
            </Reveal>
          ))}
        </div>
      </div>

      <Dialog open={!!active} onOpenChange={(o) => !o && setActive(null)}>
        <DialogContent className="max-w-3xl bg-transparent border-0 p-0 shadow-none">
          {active && <img src={wixImgFull(active)} alt="LAJO" className="w-full h-auto rounded-sm" />}
        </DialogContent>
      </Dialog>
    </section>
  );
};

export default Gallery;
